var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4435 76.7903C58.0885 81.012 53.3335 80.3454 48.7563 78.3457C43.9125 76.3015 39.4686 76.2126 34.3581 78.3457C27.9589 81.1009 24.5816 80.301 20.7598 76.7903C-0.926309 54.4376 2.27329 20.3974 26.8924 19.1531C32.8916 19.4642 37.0689 22.4416 40.5796 22.7082C45.8233 21.6417 50.8449 18.5754 56.4442 18.9754C63.1545 19.5086 68.2205 22.175 71.5534 26.9744C57.6885 35.2844 60.977 53.5488 73.6865 58.6593C71.1535 65.3251 67.865 71.9465 62.399 76.8347L62.4435 76.7903ZM40.1352 18.8865C39.4686 8.97664 47.512 0.799899 56.7553 0C58.044 11.4652 46.3566 19.9975 40.1352 18.8865Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1);
export default __webpack_public_path__ + "static/media/s1.098720eb72196dee4dec46272734b926.svg";
export { ForwardRef as ReactComponent };